var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPatternDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 830,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "95.861%",
    x2: "10.913%",
    y1: "2.476%",
    y2: "101.718%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e3f9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "95.937%",
    x2: "10.848%",
    y1: "2.476%",
    y2: "101.718%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e3f9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 800c48.557-184.991 167.048-301.57 355.473-349.737C543.898 402.096 688.074 252.008 788 0v800H0z",
    transform: "rotate(180 394 400)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M413 800c25.696-97.814 88.4-159.455 188.112-184.924C700.824 589.608 777.12 510.25 830 377v423H413z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternDesktop);
export default __webpack_public_path__ + "static/media/bg-pattern-desktop.a141d11668e0a8bcdfc00888317157b9.svg";
export { ForwardRef as ReactComponent };